export class VcontractsExcelModel {
      public TipoAcuerdo : string
      public Estado: string;
      public Iata : string
      public TipoAgencia : string
      public TipoConexion : string
      public NombreComercial : string
      public IDFiscalAgy : string
      public FechaAceptacion : string
      public FechaAvisoTerm : string
      public RepresentanteLegal : string
      public TipoIDRepLegal : string
      public NumeroIDRepLegal : string
      public Region : string
      public Pais : string
      public EstadoAcuerdo : string
      public InicioGarantia : string
      public FinGarantia : string
      public NumeroGarantia : string
      public TipoGarantia : string
}